import { AxiosInstance } from 'axios';
import { DataFetcherFunction } from '@/compiler/types';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';
import { userInterface, UserUuid } from '../users';

export type AdminPlatformRole = 'developer' | 'customer_service' | 'partner';

export interface AdminUser extends userInterface {
    platformRoles: AdminPlatformRole[]
}

const partnerAccessUrl = (userUuid: UserUuid): string => `/api/admin/users/${encodeURIComponent(userUuid)}/partner-access`;

export default (axios: AxiosInstance = baseAxios): {
    searchUsers: DataFetcherFunction<AdminUser>
    grantPartnerAccess: (userUuid: UserUuid) => Promise<AdminUser>
    removePartnerAccess: (userUuid: UserUuid) => Promise<AdminUser>
} => ({
    searchUsers: fetchPaginatedDataFunction<AdminUser>('/api/admin/users/search', undefined, axios),

    grantPartnerAccess: async (userUuid: UserUuid): Promise<AdminUser> => {
        const response = await axios.put<{ data: AdminUser }>(partnerAccessUrl(userUuid));

        return response.data.data;
    },

    removePartnerAccess: async (userUuid: UserUuid): Promise<AdminUser> => {
        const response = await axios.delete<{ data: AdminUser }>(partnerAccessUrl(userUuid));

        return response.data.data;
    },
});
